import { Object3D } from 'three';

import { FNode } from '../types/node.js';
/**
 * Get the graph node from the object
 */
export const getNodeFromObject = (object: Object3D): FNode | null => {
  if (object.userData?.node) {
    return object.userData.node;
  }

  return null;
};
